import { render, staticRenderFns } from "./ApexBar.vue?vue&type=template&id=3579975e&"
import script from "./ApexBar.vue?vue&type=script&lang=js&"
export * from "./ApexBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports